<template>
	<div class="row" style="height: 100%" :key="modalKey">
		<div class="col-sm-12 col-md-12 col-lg-7 col-xl-8 pr-0" id="left-panel" style="display: flex; flex-direction: column;">
			<div class="bg-dark-noise modal-topbar p-2" style="display: flex; flex-direction: row;">
				<div class="d-flex justify-content-start align-self-center">
					<div @click="close" class="modal-button-sm modal-button--white"><i class="fas fa-times"></i></div>
				</div>
				<div class="d-flex justify-content-center align-self-center" style="flex-grow: 100;">
					<div @click="prev(canvas.id)" class="modal-button-sm modal-button--white align-self-center" :class="{'modal-button--disabled' : hasPrev(canvas.id) === null}"><i class="fas fa-chevron-left"></i></div>
					<div class="modal-title text-white mx-2"><b>{{canvas.label}}</b></div>
					<div @click="next(canvas.id)" class="modal-button-sm modal-button--white align-self-center" :class="{'modal-button--disabled' : hasNext(canvas.id) === null}"><i class="fas fa-chevron-right"></i></div>
				</div>
				<div class="float-right mr-2">
					<button class="btn btn-outline-light btn-sm btn-report" type="button" @click="$bvModal.show('report-issue-modal')" :disabled="canvas.is_reported === 1">{{ __('translations.button.report') }}</button>
				</div>
			</div>
			<div id="openseadragon" ref="osd"></div>
			<div class="openseadragon-controls">
				<div id="zoom-in" class="modal-button control-button"><i class="fas fa-search-plus"></i></div>
				<div id="home" class="modal-button control-button"><i class="fas fa-home"></i></div>
				<div id="zoom-out" class="modal-button control-button"><i class="fas fa-search-minus"></i></div>
			</div>
		</div>
		<div class="col-sm-0 col-md-0 col-lg-5 col-xl-4 pl-0" id="right-panel">
			<transition name="component-fade" mode="out-in">
				<div v-if="!wikidataSearchFlag && !annotationFormFlag" style="height: 100%; display: flex; flex-direction: column;">
					<div class="bg-light-noise modal-topbar py-2">
						<div class="navbar modal-topbar-content" role="tablist">
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'general'}" @click="activeTab = 'general'" id="general-tab" data-toggle="tab" href="#general" role="tab" aria-controls="general" aria-selected="true">{{ __('translations.tab.general') }}</a>
							<a class="nav-link text-dark p-0 mr-3" :class="{'active' : activeTab === 'annotation'}" @click="activeTab = 'annotation'" id="annotation-tab" data-toggle="tab" href="#annotation" role="tab" aria-controls="annotation" aria-selected="false">{{ __('translations.tab.annotation') }}<span v-show="canvas.annotations.length > 0">&nbsp;({{canvas.annotations.length}})</span></a>
							<a class="nav-link text-dark p-0" :class="{'active' : activeTab === 'metadata'}" @click="activeTab = 'metadata'" id="annotation-tab" data-toggle="tab" href="#metadata" role="tab" aria-controls="metadata" aria-selected="false">{{ __('translations.tab.metadata') }}<span v-show="canvas.metadatas.length > 0">&nbsp;({{canvas.metadatas.length}})</span></a>
						</div>
					</div>
					<div class="tab-content p-3" style="flex: 1; overflow-y: auto; overflow-x: hidden;" ref="tab-content">
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'general'}" id="general" role="tabpanel" aria-labelledby="general-tab">
							<transition name="message-fade">
								<div v-if="canvas.is_reported === 1" class="alert alert-warning py-1" role="alert">
									<small>{{ __('translations.message.image_issue') }} {{ __('translations.issue_type.' + canvas.reported_issue_type) }}</small>
								</div>
							</transition>
							<date :source="canvas" sourceType="canvas"></date>
							<wikidata-tags :image="canvas"></wikidata-tags>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'annotation'}" id="annotation" role="tabpanel" aria-labelledby="annotation-tab">
							<annotations :artifact="canvas" v-on:annotation-selected="onAnnotationSelected"></annotations>
						</div>
						<div class="tab-pane fade" :class="{'show active' : activeTab === 'metadata'}" id="metadata" role="tabpanel" aria-labelledby="metadata-tab">
							<metadata :source="canvas" sourceType="canvas"></metadata>
						</div>
					</div>
				</div>
				<div class="wikidata-search-container" v-else-if="wikidataSearchFlag">
					<div class="bg-light-noise modal-topbar pl-3 py-2" style="display: flex; flex-direction: row;">
						<div class="modal-topbar-content"><b>{{ __('translations.title.wikidata_search') }}</b></div>
						<div class="d-flex justify-content-end align-self-center p-2" @click="hideWikidataSearch" style="flex-grow: 100;">
							<i class="fas fa-times fa-lg p-2" style="cursor: pointer;"></i>
						</div>
					</div>
					<div style="flex-grow: 100%; overflow: hidden;" class="p-3">
						<wikidata-search taggableType="canvas"
							v-on:selected-tag="onSelectedTag"
							v-on:deselected-tag="onDeselectedTag"
							:populateWith="canvas.tags"></wikidata-search>
					</div>
				</div>
				<component v-else-if="annotationFormFlag" v-bind:is="annotationFormComponent" :artifact="canvas" :populateWith="annotationSelected" ref="annotationForm"></component>
			</transition>
		</div>
		
		<report-issue-form :artifact="canvas" v-on:reported="onReported"></report-issue-form>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import Date from './Date'
import Metadata from './Metadata'
import WikidataTags from './WikidataTags'
import WikidataSearch from './WikidataSearch'
import ModalMixin from '../mixins/ModalMixin'
import Util from '../mixins/Util'

export default {
	mixins: [ModalMixin, Util],
	components: {
		Date,
		Metadata,
		WikidataTags,
		WikidataSearch
	},
	computed: {
		...mapGetters([
			'canvas'
		]),
		modalKey() {
			// Changing the key re-renders the modal.
			return 'canvas-modal-' + this.canvas.id;
		}
	},
	methods: {
		openseadragon() {
			var tileSources = null;
			
			if (typeof this.canvas.iiif_info.sizes !== 'undefined' && this.canvas.iiif_info.sizes.length > 0) {
				tileSources = {
					"@context": "http://iiif.io/api/image/2/context.json",
			        "@id": this.canvas.path,
			        "profile": ["http://iiif.io/api/image/2/level2.json"],
			        "protocol": "http://iiif.io/api/image",
			        "width": this.canvas.iiif_info.width,
			        "height": this.canvas.iiif_info.height,
				};
			} else {
				tileSources = {
		            type: 'image',
		            url:  this.canvas.src
		        };
			}
			
			this.viewer = OpenSeadragon({
				id: 'openseadragon',
				tileSources: tileSources,
				zoomInButton:   'zoom-in',
				zoomOutButton:  'zoom-out',
				homeButton:		'home',
				showFullPageControl: false
			});
			
			this.configureOpenseadragon();
		},
		onSelectedTag(tag) {
			axios.post('/canvas/tag/save', {id: this.canvas.id, tag: tag}).then(response => {
				// Update the current list of tags.
				this.canvas.tags.push(response.data);
				this.updateTags();
			}).catch(err => {
				console.log(err);
			})
		},
		onDeselectedTag(tag) {
			axios.post('/canvas/tag/delete', {tag: tag}).then(response => {
				this.canvas.tags.splice(this.canvas.tags.indexOf(tag), 1);
				this.updateTags();
			}).catch(err => {
				console.log(err)
			})
		},
		onReported(issueType) {
			Vue.set(this.canvas, 'is_reported', 1);
			Vue.set(this.canvas, 'reported_issue_type', issueType);
		},
		onUnreported() {
			Vue.set(this.canvas, 'is_reported', 0);
		}
	}
}
</script>